import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import * as Styled from './ProductCard.Skeleton.styles';

var ProductCardSkeleton = function ProductCardSkeleton(_ref) {
  var height = _ref.height,
      width = _ref.width,
      speed = _ref.speed,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      isPortrait = _ref.isPortrait,
      mobileLayout = _ref.mobileLayout;
  return /*#__PURE__*/React.createElement(Styled.Wrapper, null, isPortrait ? /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "pc-content-loader--clothing",
    className: "xs-hidden md-block"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "5",
    rx: "5",
    ry: "5",
    width: "270",
    height: "360"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "370",
    rx: "5",
    ry: "5",
    width: "70",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "405",
    rx: "4",
    ry: "4",
    width: "260",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "450",
    rx: "4",
    ry: "4",
    width: "130",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "500",
    rx: "4",
    ry: "4",
    width: "45",
    height: "45"
  })) : /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "pc-content-loader--default",
    className: "xs-hidden md-block"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "5",
    rx: "5",
    ry: "5",
    width: "260",
    height: "260"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "280",
    rx: "4",
    ry: "4",
    width: "260",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "325",
    rx: "4",
    ry: "4",
    width: "130",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "410",
    rx: "4",
    ry: "4",
    width: "220",
    height: "50"
  })), mobileLayout === 'vertical' ? /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "pc-mobile-content-loader--vertical",
    className: "md-hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "5",
    rx: "5",
    ry: "5",
    width: "260",
    height: "260"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "280",
    rx: "4",
    ry: "4",
    width: "260",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "325",
    rx: "4",
    ry: "4",
    width: "130",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "370",
    rx: "4",
    ry: "4",
    width: "260",
    height: "40"
  })) : /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height - 450),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "pc-mobile-content-loader",
    className: "md-hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "5",
    ry: "5",
    width: "65",
    height: "65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "0",
    rx: "5",
    ry: "5",
    width: "200",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "25",
    rx: "5",
    ry: "5",
    width: "80",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "85",
    rx: "5",
    ry: "5",
    width: "35",
    height: "35"
  })));
};

ProductCardSkeleton.propTypes = {
  /**
   * Optional prop for the height
   */
  height: PropTypes.number,

  /**
   * Optional prop for the width
   */
  width: PropTypes.number,

  /**
   * Optional prop for the speed of the gradient
   */
  speed: PropTypes.number,

  /**
   * Optional prop for the primary colour for the gradient
   */
  primaryColor: PropTypes.string,

  /**
   * Optional prop for the secondary colour for the gradient
   */
  secondaryColor: PropTypes.string,

  /**
   * Optional prop to sepcify if the product is of type clothing
   */
  isPortrait: PropTypes.bool,

  /**
   * Optional prop to specify which layout to use on mobile and tablet viewports
   */
  mobileLayout: PropTypes.oneOf(['horizontal', 'vertical'])
};
ProductCardSkeleton.defaultProps = {
  height: 570,
  width: 270,
  speed: 1,
  primaryColor: '#f2f2f2',
  secondaryColor: '#ecebeb',
  isPortrait: false,
  mobileLayout: 'horizontal'
};
export default ProductCardSkeleton;